export default __webpack_public_path__ + "static/media/img-0643-north-macedonia-full-face.5843d55a.png";